module.exports = __webpack_public_path__ + "media/online_learning/pros-cons-961e5e4f.svg";